import { inject, Injectable } from '@angular/core';
import { IBankAccountsState } from 'src/models/bank-accounts.model';
import { signalStore, withState, withMethods } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { catchError, map, of, pipe, switchMap, tap } from 'rxjs';
import { ELoadingEntity } from 'src/models/generic-store.model';
import { withDevtools, updateState } from '@angular-architects/ngrx-toolkit';
import { RestApiService } from 'src/services/rest-api.service';
import { withError, withLoading, withoutError, withoutLoading, withRequestStatus } from '../store-features/with-request-status.store-feature';

enum EBankAccountsActions {
  BANK_ACCOUNTS_REQUEST = '[BankAccounts] Bank Accounts Request',
  BANK_ACCOUNTS_SUCCESS = '[BankAccounts] Bank Accounts Success',
  BANK_ACCOUNTS_FAILURE = '[BankAccounts] Bank Accounts Failure',
}

const initialBankAccountsState: IBankAccountsState = {
  bankAccounts: [],
};

const STORE_NAME = 'bankAccounts';

@Injectable({ providedIn: 'root' })
export class BankAccountsStore extends signalStore(
  withState(initialBankAccountsState),
  withDevtools(STORE_NAME),
  withRequestStatus(),
  withMethods((store, restApiService = inject(RestApiService)) => {

    const getBankAccounts = rxMethod<{ portfolioId: number }>(
      pipe(
        tap(() =>
          updateState(store, EBankAccountsActions.BANK_ACCOUNTS_REQUEST, ({ loadingProps }) => ({
            ...withLoading(ELoadingEntity.BANK_ACCOUNTS, loadingProps),
          }))
        ),
        switchMap(({ portfolioId }) =>
          restApiService.getBankAccounts(portfolioId).pipe(
            map((response) =>
              updateState(store, EBankAccountsActions.BANK_ACCOUNTS_SUCCESS, ({ loadingProps, errorProps }) => ({
                bankAccounts: response,
                ...withoutLoading(ELoadingEntity.BANK_ACCOUNTS, loadingProps),
                ...withoutError(ELoadingEntity.BANK_ACCOUNTS, errorProps),
              }))
            ),
            catchError((error) =>
              of(
                updateState(store, EBankAccountsActions.BANK_ACCOUNTS_FAILURE, ({ loadingProps, errorProps }) => ({
                  bankAccounts: [],
                  ...withoutLoading(ELoadingEntity.BANK_ACCOUNTS, loadingProps),
                  ...withError(ELoadingEntity.BANK_ACCOUNTS, { error, errorParams: { portfolioId } }, errorProps),
                }))
              )
            )
          )
        )
      )
    );

    return {
      getBankAccounts,
    };
  })
) {}
